export const isObjectEmpty = (obj: Object) => {
  return Object.keys(obj).length === 0;
};
